var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDeltaicon = function SvgDeltaicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#015969",
    fillRule: "evenodd",
    d: "M8.408.578v14h8.083l-8.083-14Zm0 4.238v7.644h4.413L8.408 4.816Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#01869E",
    fillRule: "evenodd",
    d: "M8.408.578v14H.325l8.083-14Zm0 4.238v7.644H3.995l4.413-7.644Z",
    clipRule: "evenodd"
  })));
};
export default SvgDeltaicon;